/*
 * Purpose: Flow Templates gallery — clone starter flows
 * Last modified: 2026-07-01 | Agent
 * Completeness: 100
 */
import { useSearchParams } from 'react-router-dom';
import { TemplateLibrary } from '@/components/TemplateLibrary';

export default function FlowTemplatesPage() {
  const [params] = useSearchParams();
  const defaultTab = params.get('view') === 'learning' ? 'learning' : 'gallery';

  return (
    <div className="space-y-4">
      <TemplateLibrary defaultTab={defaultTab} />
    </div>
  );
}
